import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ApplicationForm from './pages/ApplicationForm';
import ReferralsList from './pages/ReferralsList';
import AuthCallback from './pages/AuthCallback';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { validateConfig } from './config/env';
import './App.css';

function App() {
  const { isValid, missingVars } = validateConfig();
  
  if (!isValid) {
    console.warn('Missing environment variables:', missingVars);
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            <Route 
              path="/:policySystem" 
              element={
                <ProtectedRoute>
                  <ReferralsList/>
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/:policySystem/application/:id" 
              element={
                <ProtectedRoute>
                  <ApplicationForm />
                </ProtectedRoute>
              } 
            />
            
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
